import * as React from 'react';
import { Link } from '@cian/ui-kit';
import { IconActionArrowLeft24 } from '@cian/ui-kit-design-tokens/icons';

export const AllRealtorLinkMobile = () => (
  <Link
    href="/realtors/"
    fontSize="M"
    beforeIcon={<IconActionArrowLeft24 color="icon-main-default" />}
    spacingSize="XS"
  >
    Все риелторы
  </Link>
);
